import { getValue } from "../../utils/object.utils";

export const transformAcademicPricesTableData = (
  academixPricesLists: Array<any>
): any[] => {
  const transformDatForTable = academixPricesLists.map(
    (academicPrice: any): any => {
      return {
        id: getValue(academicPrice, "id"),
        className: getValue(academicPrice, "classes.name"),
        admission_fee: getValue(academicPrice, "admission_fee"),
        annual_fee: getValue(academicPrice, "annual_fee"),
        extra_class_fee: getValue(academicPrice, "extra_class_fee"),
        monthly_fee: getValue(academicPrice, "monthly_fee"),
        stationery_fee: getValue(academicPrice, "stationery_fee"),
        exam_fee: getValue(academicPrice, "exam_fee"),
        extra_carricular_fee: getValue(academicPrice, "extra_carricular_fee"),
      };
    }
  );

  return transformDatForTable;
};
